import React from 'react';
import {
  Button,
  ButtonVariant,
  useWizardContext,
  WizardFooterWrapper
} from '@patternfly/react-core';

import { useTranslation } from 'localization/useTranslation';
import PropTypes from 'prop-types';


import './Footer.css';
const Footer = ({ isNextDisabled = false, onActionClick, isActionExecuting, actionButtonLabel }) => {
  const { steps, activeStep, goToNextStep, goToPrevStep, close } = useWizardContext();
  const T = useTranslation();
  const isLastStep = activeStep.index === steps.length;
  const isFirstStep = activeStep.index === 1;

  return (<WizardFooterWrapper>
    { isLastStep && (<Button size="sm" variant={ButtonVariant.primary} onClick={onActionClick}
      isLoading={isActionExecuting}>
      { actionButtonLabel ?? T.common.create }
    </Button>)
    }
    { !isLastStep &&
        (<Button variant={ButtonVariant.primary} isLoading={isActionExecuting} onClick={goToNextStep} isDisabled={isNextDisabled}>{ T.common.next }</Button>)
    }
    { !isFirstStep &&
        <Button variant={ButtonVariant.secondary} onClick={goToPrevStep}>
              Back
        </Button>
    }
    <Button variant={ButtonVariant.link} onClick={close} isDisabled={false}>{ T.common.cancel }</Button>
  </WizardFooterWrapper>);
};

Footer.propTypes = {
  isNextDisabled: PropTypes.bool,
  isActionExecuting: PropTypes.bool,
  onActionClick: PropTypes.func,
  actionButtonLabel: PropTypes.string
};

export default Footer;
